module.exports = __webpack_public_path__ + "img/max-file-transfer--zip.f579c998.svg";